export class Subscription {
  constructor(unsubscribe) {
    this.unsubscribe = unsubscribe;
  }
}

export class Observable {
  constructor(subscribe) {
    this.subscribe = subscribe;
  }
}

export const timeout = (miliseconds) => {
  const _subscribe = (observerOrNext, error, complete) => {
    let observer;

    if (typeof observerOrNext === 'function') {
      observer = {
        next: observerOrNext,
        error: error || (() => {}),
        complete: complete || (() => {}),
      };
    } else {
      observer = observerOrNext;
    }

    const t = setTimeout(() => {
      observer.next();
      observer.complete();
    }, miliseconds);

    return new Subscription(() => {
      clearTimeout(t);
    });
  };

  return new Observable(_subscribe);
};

export const interval = (miliseconds) => {
  const _subscribe = (observerOrNext, error = () => {}, complete = () => {}) => {
    let observer;

    if (typeof observerOrNext === 'function') {
      observer = {
        next: observerOrNext,
        error,
        complete,
      };
    } else {
      observer = observerOrNext;
    }

    const i = setInterval(() => {
      observer.next();
    }, miliseconds);

    return new Subscription(() => {
      clearInterval(i);
    });
  };

  return new Observable(_subscribe);
};

export const from = (array, miliseconds) => {
  const _subscribe = (observerOrNext, error, complete) => {
    let observer;

    if (typeof observerOrNext === 'function') {
      observer = {
        next: observerOrNext,
        error: error || (() => {}),
        complete: complete || (() => {}),
      };
    } else {
      observer = observerOrNext;
    }

    const timeouts = [];

    const delay = (ms) =>
      new Promise((resolve) => {
        const t = setTimeout(resolve, ms);
        timeouts.push(t);
        return t;
      });

    (async () => {
      for (let i = 0; i < array.length; i++) {
        observer.next(array[i]);
        await delay(miliseconds);
      }
      observer.complete();
    })();

    return new Subscription(() => {
      timeouts.forEach((t) => clearTimeout(t));
    });
  };

  return new Observable(_subscribe);
};
